"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureLogger = void 0;
function configureLogger(options) {
    window.Logger_shouldDebug = options.shouldDebug || window.Logger_shouldDebug;
    window.Logger_logStyle = options.logStyle || window.Logger_logStyle;
    window.Logger_infoStyle = options.infoStyle || window.Logger_infoStyle;
    window.Logger_warningStyle = options.warningStyle || window.Logger_warningStyle;
    window.Logger_errorStyle = options.errorStyle || window.Logger_errorStyle;
}
exports.configureLogger = configureLogger;
configureLogger({
    shouldDebug: window.location.href.includes("debug=true"),
    logStyle: "color:#333;padding:1px 10px;background:#c8d6e5",
    infoStyle: "color:white;padding:1px 10px;background:#2e86de;",
    warningStyle: "color:white;padding:1px 10px;background:#ff9f43;",
    errorStyle: "color:white;padding:1px 10px;background:red;",
});
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!window.Logger_shouldDebug)
            return;
        console.log.apply(console, __spreadArrays(["%c" + message, window.Logger_logStyle], optionalParams));
    };
    Logger.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!window.Logger_shouldDebug)
            return;
        console.info.apply(console, __spreadArrays(["%c" + message, window.Logger_infoStyle], optionalParams));
    };
    Logger.warning = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!window.Logger_shouldDebug)
            return;
        console.warn.apply(console, __spreadArrays(["%c" + message, window.Logger_warningStyle], optionalParams));
    };
    Logger.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (!window.Logger_shouldDebug)
            return;
        console.error.apply(console, __spreadArrays(["%c" + message, window.Logger_errorStyle], optionalParams));
    };
    return Logger;
}());
exports.default = Logger;
//# sourceMappingURL=logger.js.map